import { useEffect, useState } from 'react';
import { restoreDelete } from './EditTranscriptMenu/utils';
import { TimelineDeleteChangeDuringDrag } from './types';
import { mergeDeletes } from '@/player-config/src/utils/assetMetadataUtils';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';
import { ClipDeletes } from '@/player-config/src/types/RemotionPlayerConfigTypes/Segment/CompositeSegment';

export default function useDeletesWithDragChanges({ allDeletes }: { allDeletes: Record<string, ClipDeletes> }) {
  const [newDeletes, setNewDeletes] = useState<Record<string, ClipDeletes>>(allDeletes);
  const [compositeSegmentId, setCompositeSegmentId] = useState<string | null>(null);
  useEffect(() => {
    const onDeleteChangeDuringDrag = ({
      type,
      startTime,
      endTime,
      compositeSegmentId
    }: TimelineDeleteChangeDuringDrag) => {
      if (type === 'add') {
        setNewDeletes({
          ...allDeletes,
          [compositeSegmentId]: mergeDeletes({
            ...(allDeletes[compositeSegmentId] || {}),
            [startTime]: {
              bounds: [startTime, endTime],
              prev_end_time: startTime,
              next_start_time: endTime
            }
          })
        });
      } else if (type === 'remove') {
        setNewDeletes({
          ...allDeletes,
          [compositeSegmentId]: restoreDelete(allDeletes[compositeSegmentId], {
            bounds: [startTime, endTime],
            prev_end_time: startTime,
            next_start_time: endTime
          })
        });
      } else if (type === 'reset') {
        setNewDeletes(allDeletes);
      }
      setCompositeSegmentId(compositeSegmentId);
    };
    setNewDeletes(allDeletes);
    const eventListener = EventBus.on(CustomEvents.TimelineDeleteChangeDuringDrag, onDeleteChangeDuringDrag);
    return () => {
      EventBus.off(CustomEvents.TimelineDeleteChangeDuringDrag, eventListener);
    };
  }, [allDeletes]);

  return { newDeletes, compositeSegmentId };
}
